module.exports = __webpack_public_path__ + "img/2024-03-19b_1.fd128e46.jpg";